// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PGodq","icon":"styles_icon__ii9BG","title":"styles_title__7ahbU","des":"styles_des__Xy-9B","btn":"styles_btn__xBJMF"};